  import React, { useState } from "react";
  import { Disclosure } from "@headlessui/react";
  import { FiFilter } from "react-icons/fi";

  const Workprogram = () => {
    const programs = [
      {
        name: "Invoice Receipt and Validation Review",
        description: "Detailed audit work program for auditing AP invoice receipting process.",
        documentUrl: "/wpfinance/invoicereceipt.pdf",
        imageUrl: "/images/wp/invoice_receipt.png",
        department: "Accounting",
        subDepartment: "Accounts Payable",
        process: ["Invoice Receipt & Validation"],
      },
      {
        name: "Vendor Setup & Maintenance Review",
        description: "Detailed audit work program for auditing vendor setup and maintenance.",
        documentUrl: "/wpfinance/vendorsetup.pdf",
        imageUrl: "/images/wp/vendorsetup.png",
        department: "Accounting",
        subDepartment: "Accounts Payable",
        process: ["Vendor setup & Maintenance"],
      },
      {
        name: "Payment Processsing of Invoices Review",
        description: "Detailed audit work program for payment processing.",
        documentUrl: "/wpfinance/paymentprocessing.pdf",
        imageUrl: "/images/wp/paymentprocessing.png",
        department: "Accounting",
        subDepartment: "Accounts Payable",
        process: ["Payment Processing"],
      },
      {
        name: "Customer Invoicing Review",
        description: "Detailed audit work program for customer invoicing.",
        documentUrl: "/wpfinance/customerinvoicing.pdf",
        imageUrl: "/images/wp/customerinvoicing.png",
        department: "Accounting",
        subDepartment: "Accounts Receivable",
        process: ["Customer Invoicing"],
      },
      

    
    ];

    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [selectedSubDepartment, setSelectedSubDepartment] = useState("");
    const [selectedProcess, setSelectedProcess] = useState("");

    // Departments are always derived from all programs
    const uniqueDepartments = [...new Set(programs.map((p) => p.department))];

    // Sub-Departments depend on the selected Department
    const uniqueSubDepartments = selectedDepartment
      ? [
          ...new Set(
            programs
              .filter((p) => p.department === selectedDepartment)
              .map((p) => p.subDepartment)
          ),
        ]
      : [];

    // Processes depend on both the selected Department and Sub-Department
    const uniqueProcesses =
      selectedDepartment && selectedSubDepartment
        ? [
            ...new Set(
              programs
                .filter(
                  (p) =>
                    p.department === selectedDepartment &&
                    p.subDepartment === selectedSubDepartment
                )
                .flatMap((p) => p.process)
            ),
          ]
        : [];

    // Filter the displayed programs based on all three selections
    const filteredPrograms = programs.filter((program) => {
      const matchesDepartment =
        !selectedDepartment || program.department === selectedDepartment;
      const matchesSubDepartment =
        !selectedSubDepartment || program.subDepartment === selectedSubDepartment;
      const matchesProcess =
        !selectedProcess || program.process.includes(selectedProcess);

      return matchesDepartment && matchesSubDepartment && matchesProcess;
    });

    return (
      <div className="flex flex-col lg:flex-row">
        {/* Filter Panel */}
        <aside className="lg:w-64 bg-gray-100 p-4 rounded-lg shadow-md hidden lg:block">
          <h3 className="text-lg font-semibold text-gray-700 mb-4">Filters</h3>
          <div className="mb-6">
            <h4 className="font-medium text-gray-600">Department</h4>
            <select
              className="w-full mt-2 p-2 border rounded-md"
              value={selectedDepartment}
              onChange={(e) => {
                setSelectedDepartment(e.target.value);
                setSelectedSubDepartment("");
                setSelectedProcess("");
              }}
            >
              <option value="">Select Department</option>
              {uniqueDepartments.map((department) => (
                <option key={department} value={department}>
                  {department}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-6">
            <h4 className="font-medium text-gray-600">Sub-Department</h4>
            <select
              className="w-full mt-2 p-2 border rounded-md"
              value={selectedSubDepartment}
              onChange={(e) => {
                setSelectedSubDepartment(e.target.value);
                setSelectedProcess("");
              }}
              disabled={!selectedDepartment}
            >
              <option value="">Select Sub-Department</option>
              {uniqueSubDepartments.map((subDepartment) => (
                <option key={subDepartment} value={subDepartment}>
                  {subDepartment}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-6">
            <h4 className="font-medium text-gray-600">Process</h4>
            <select
              className="w-full mt-2 p-2 border rounded-md"
              value={selectedProcess}
              onChange={(e) => setSelectedProcess(e.target.value)}
              disabled={!selectedSubDepartment}
            >
              <option value="">Select Process</option>
              {uniqueProcesses.map((process) => (
                <option key={process} value={process}>
                  {process}
                </option>
              ))}
            </select>
          </div>
        </aside>

        {/* Mobile Filter Toggle */}
        <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button className="lg:hidden flex items-center bg-blue-500 text-white px-4 py-2 rounded-md shadow-md w-full mb-4">
                <FiFilter className="mr-2" />
                {open ? "Hide Filters" : "Show Filters"}
              </Disclosure.Button>
              <Disclosure.Panel className="p-4 bg-gray-100 rounded-lg shadow-md lg:hidden">
                <div className="mb-6">
                  <h4 className="font-medium text-gray-600">Department</h4>
                  <select
                    className="w-full mt-2 p-2 border rounded-md"
                    value={selectedDepartment}
                    onChange={(e) => {
                      setSelectedDepartment(e.target.value);
                      setSelectedSubDepartment("");
                      setSelectedProcess("");
                    }}
                  >
                    <option value="">Select Department</option>
                    {uniqueDepartments.map((department) => (
                      <option key={department} value={department}>
                        {department}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-6">
                  <h4 className="font-medium text-gray-600">Sub-Department</h4>
                  <select
                    className="w-full mt-2 p-2 border rounded-md"
                    value={selectedSubDepartment}
                    onChange={(e) => {
                      setSelectedSubDepartment(e.target.value);
                      setSelectedProcess("");
                    }}
                    disabled={!selectedDepartment}
                  >
                    <option value="">Select Sub-Department</option>
                    {uniqueSubDepartments.map((subDepartment) => (
                      <option key={subDepartment} value={subDepartment}>
                        {subDepartment}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-6">
                  <h4 className="font-medium text-gray-600">Process</h4>
                  <select
                    className="w-full mt-2 p-2 border rounded-md"
                    value={selectedProcess}
                    onChange={(e) => setSelectedProcess(e.target.value)}
                    disabled={!selectedSubDepartment}
                  >
                    <option value="">Select Process</option>
                    {uniqueProcesses.map((process) => (
                      <option key={process} value={process}>
                        {process}
                      </option>
                    ))}
                  </select>
                </div>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>

        {/* Program Cards */}
        <div className="flex-1 p-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Work Programs</h2>
          <p className="text-gray-600">
            Explore curated audit work programs tailored for various processes and departments.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
            {filteredPrograms.map((program, index) => (
              <div
                key={index}
                className="bg-gray-200 rounded-lg p-4 flex flex-col items-center justify-center shadow-md"
              >
                <img
                  src={program.imageUrl}
                  alt={`${program.name} Image`}
                  className="h-40 w-full rounded-md mb-4 object-contain"
                />
                <h3 className="text-lg font-semibold text-gray-700">
                  {program.name}
                </h3>
                <p className="text-gray-600 text-sm text-center mb-4">
                  {program.description}
                </p>
                <a
                  href={program.documentUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-2 text-blue-500 hover:underline"
                >
                  View Document
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  export default Workprogram;
